import React from 'react';
import { RichTextPageType } from '../../../lib/api/custom-page.types';
import { RichTextPageWrapper } from '../RichTextWrapper/RichTextPageWrapper';

export const RichTextCustomPage: React.FunctionComponent<RichTextPageType> = (props: RichTextPageType): JSX.Element | null => {
  if (props && Object.keys(props).length > 0) return <RichTextPageWrapper {...props} />;
  return null;
};
